<template>
  <!-- Renders Each Question Component -->
  <component
    v-if="question.IsVisible"
    :is="question.AnswerControlType"
    :question="question"
    :class="{
      'mb-8':
        question.IsVisible && question.DisplayType !== 'Layout' && !isSelfServe,
      'mb-5': isSelfServe && !question.IsRemoveMarginBottom,
    }"
    :labelClass="question.LabelClass"
    :disabled="disabled"
    @showDirectDebitRenewalInfo="$emit('showDirectDebitRenewalInfo')"
    @showPremiumBreakdownMonthly="showPremiumBreakdownMonthly"
    @showPremiumBreakdown3Months="showPremiumBreakdown3Months"
    @showPremiumBreakdownAnnual="showPremiumBreakdownAnnual"
    @shareQuote="shareQuote"
    @printQuote="printQuote"
    @change="(val) => setFirstTimeBuyerNcd(val)"
  ></component>
</template>

<script>
// ALL components for questions MUST be registered here
import CounterBase from "@/components/Counters/CounterBase";
import InputBase from "@/components/Inputs/InputBase";
import InputMask from "@/components/Inputs/InputMask";
import QuestionDate from "@/components/Questions/QuestionDate";
import LayoutAddressSearchBase from "@/components/LayoutComponents/LayoutAddressSearchBase";
import LayoutAddressSearchLexisNexis from "@/components/LayoutComponents/LayoutAddressSearchLexisNexis";
import LayoutApplicationPayment from "@/components/LayoutComponents/LayoutApplicationPayment";
import LayoutPropertyDetails from "@/components/LayoutComponents/LayoutPropertyDetails";
import LayoutTableBuilder from "@/components/LayoutComponents/LayoutTableBuilder";
import LayoutApplicationLimitedInformationStatement from "@/components/LayoutComponents/LayoutApplicationLimitedInformationStatement";
import LayoutApplicationMonthlyConfirmation from "@/components/LayoutComponents/LayoutApplicationMonthlyConfirmation";
import LayoutSolicitorEmailAddress from "@/components/LayoutComponents/LayoutSolicitorEmailAddress";
import LayoutApplicationSummaryCard from "@/components/LayoutComponents/LayoutApplicationSummaryCard";
import D2CLayoutApplicationSummaryCard from "@/components/LayoutComponents/D2CLayoutApplicationSummaryCard";
import RadioBase from "@/components/Radios/RadioBase";
import RadioButtonSecondApplicantToggleHiddenQuestion from "@/components/Radios/RadioButtonSecondApplicantToggleHiddenQuestion";
import RadioBaseToggleHiddenQuestion from "@/components/Radios/RadioBaseToggleHiddenQuestion";
import RadioButtonBase from "@/components/Radios/RadioButtonBase";
import RadioButtonCard from "@/components/Radios/RadioButtonCard";
import RadioButtonToggleHiddenQuestion from "@/components/Radios/RadioButtonToggleHiddenQuestion";
import RadioImageBase from "@/components/Radios/RadioImageBase";
import RadioImageToggleHiddenQuestion from "@/components/Radios/RadioImageToggleHiddenQuestion";
import SelectBase from "@/components/Selects/SelectBase";
import SelectIndustry from "@/components/Selects/SelectIndustry";
import SelectOccupation from "@/components/Selects/SelectOccupation";
import SelectToggleHiddenQuestion from "@/components/Selects/SelectToggleHiddenQuestion";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuestionBase",
  components: {
    CounterBase,
    InputBase,
    InputMask,
    QuestionDate,
    LayoutAddressSearchBase,
    LayoutAddressSearchLexisNexis,
    LayoutApplicationPayment,
    LayoutPropertyDetails,
    LayoutTableBuilder,
    LayoutApplicationLimitedInformationStatement,
    LayoutApplicationMonthlyConfirmation,
    LayoutSolicitorEmailAddress,
    LayoutApplicationSummaryCard,
    D2CLayoutApplicationSummaryCard,
    RadioBase,
    RadioButtonSecondApplicantToggleHiddenQuestion,
    RadioBaseToggleHiddenQuestion,
    RadioButtonBase,
    RadioButtonCard,
    RadioButtonToggleHiddenQuestion,
    RadioImageBase,
    RadioImageToggleHiddenQuestion,
    SelectBase,
    SelectIndustry,
    SelectOccupation,
    SelectToggleHiddenQuestion,
  },
  computed: { ...mapGetters(QUESTIONS_MODULE, ["isSelfServe"]) },
  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions("questions", ["setFirstTimeBuyerNcd"]),
    showPremiumBreakdownMonthly(selectedQuote) {
      this.$emit("showPremiumBreakdownMonthly", selectedQuote);
    },
    showPremiumBreakdown3Months(selectedQuote) {
      this.$emit("showPremiumBreakdown3Months", selectedQuote);
    },
    showPremiumBreakdownAnnual(selectedQuote) {
      this.$emit("showPremiumBreakdownAnnual", selectedQuote);
    },
    shareQuote(quoteId) {
      this.$emit("shareQuote", quoteId);
    },
    printQuote(selectedQuote) {
      this.$emit("printQuote", selectedQuote);
    },
  },
};
</script>

<style scoped>
.d2c-payment-button {
  margin-bottom: 34px !important;
}

.d2c-payment-select {
  margin-bottom: 52px !important;
}
</style>
